import { render } from "./LogicalRouterTab.vue?vue&type=template&id=5e10a979"
import script from "./LogicalRouterTab.vue?vue&type=script&lang=js"
export * from "./LogicalRouterTab.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/cloudstack/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__